import { Divider } from '@advanza/ui'
import { RECLAIM_PERCENTAGE_BENCHMARK_FACTOR } from '@trustoo/constants/reclaims'
import { useReclaimsList } from 'hooks/reclaimHooks'
import React from 'react'
import Chart from 'react-google-charts'

const ReclaimStats = ({ filterId = 'all', defaultOptions = {} }) => {
    const { stats = {} } = useReclaimsList(filterId, defaultOptions)

    if (Object.keys(stats).length === 0) {
        return null
    }

    const {
        nrReclaimsPerReason,
        reclaimPercentage3Months,
        reclaimPercentageAllTime,
        serviceReclaimPercentage3Months,
        serviceReclaimPercentage12Months,
    } = stats
    const data = nrReclaimsPerReason.map((reason) => [
        reason.reason ? reason.reason : 'No reason',
        Number(reason.amount),
    ])
    data.unshift(['Reclaim', 'Reasons'])

    return (
        <>
            <Chart
                width={'500px'}
                height={'300px'}
                chartType="PieChart"
                loader={<div>Loading Chart</div>}
                data={data}
                options={{ title: 'Reclaims by reason' }}
            />
            <b>Reclaim percentage</b>
            <Divider m />
            <div className="grid grid-cols-2 gap-2">
                <div>Last 3 months: {reclaimPercentage3Months}%</div>
                <div>
                    Benchmark:{' '}
                    {Math.round(
                        RECLAIM_PERCENTAGE_BENCHMARK_FACTOR * serviceReclaimPercentage3Months,
                    )}
                    %
                </div>
                <div>Entire timeline: {reclaimPercentageAllTime}%</div>
                <div>
                    Benchmark:{' '}
                    {Math.round(
                        RECLAIM_PERCENTAGE_BENCHMARK_FACTOR * serviceReclaimPercentage12Months,
                    )}
                    %
                </div>
            </div>
        </>
    )
}

export default ReclaimStats
